// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__105nJ","main":"style_main__1Q_H5","answer":"style_answer__8hkK4","text_container":"style_text_container__yNe_V","save":"style_save__3A9xK"};